import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Unit from "./unit";
import ApplicationHome from "./applicationDashboard";
import ChannelDashboard from "./channelDashboard";

// The old store/catalogue (/application/library, /application/explore/:id) and
// payment-response pages were left over from a previous paid product and are no
// longer routed. The user's subscriptions are kept in sync by the listener in
// containers/auth/redux_actions.js, so no extra listener is attached here.
let Application = class Application extends Component {
  render() {
    return <Switch>
      <Route path="/application/channel/:yearId/:channelId" component={ChannelDashboard} />
      <Route path="/application/unit/:unitId" component={Unit} />
      <Route path="/application/dashboard" component={ApplicationHome} />
      <Route exact path="/application" component={ApplicationHome} />
      <Redirect to="/application/dashboard" />
    </Switch>
  }
}

const mapStateToProps = state => ({ userState: state.userState, auth: state.auth });
export default withRouter(connect(mapStateToProps, null)(Application));
